<template>
    <div id="applicants">
        <v-overlay absolute="" opacity="0.2" :value="loader">
            <v-progress-circular :color="appColor" indeterminate size="32"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar.status" top :color="snackbar.color" :timeout="snackbar.timeout">
            <v-icon class="mr-1">{{ snackbar.icon }}</v-icon> {{ snackbar.message }}
        </v-snackbar>
        <applicants-toolbar></applicants-toolbar>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <applicants-manager ref="applicantManager" :data="data" :permission="permission"
                        :residenceTermDefault="residenceTermDefault" :residenceTerms="residenceTerms"
                        :searchBool="searchBool" @refreshData="refreshData" @setData="setData" @setLoader="setLoader"
                        @setNotification="setNotification" @setSearch="setSearch">
                    </applicants-manager>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import auth from '../../js/auth';
import ApplicantsManager from '../../components/Admin/Applicants/Manager';
import ApplicantsToolbar from '../../components/Admin/Applicants/Toolbar';

export default {
    name: 'applicants',
    components: {
        ApplicantsManager,
        ApplicantsToolbar
    },
    props: ['id'],
    data() {
        return {
            activeApplicant: true,
            data: [],
            loader: true,
            permission: {},
            refreshTimer: '',
            residenceTermDefault: '',
            residenceTerms: [],
            searchBool: false,
            snackbar: {
                color: 'success',
                icon: '',
                message: '',
                status: false,
                timeout: 5000
            }
        }
    },
    methods: {
        getApplicantsData() {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getApplicants&residenceTerm=default`;

            // Refresh based on search
            if (this.searchBool) {
                let residenceTerm = this.$refs.applicantManager ? this.$refs.applicantManager.getResidenceTerm() : "";
                let searchTerm = this.$refs.applicantManager ? this.$refs.applicantManager.getSearchTerm() : "";
                api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getApplicants&residenceTerm=${residenceTerm}&search=${searchTerm}`;
            }

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to view this resource. Please refresh your application.`, true);
                    } else if (!json.result.match(/OK/i)) {
                        that.setNotification('#ffb822', 'mdi-alert-circle', `System configuration applicants data could not be retrieved. Please contact your system administrator.`, true);
                    }

                    that.data = json.data;
                    that.residenceTerms = json.residenceTerms;

                    // Set default values
                    if (!that.residenceTermDefault && json.default && json.default.term) {
                        that.residenceTermDefault = json.default.term;
                        that.$refs.applicantManager.setResidenceTerm(json.default.term);
                    }

                    // Set active applicant if id is passed
                    if (that.activeApplicant && that.id) {
                        that.activeApplicant = false;
                        that.setActiveApplicant();
                    } else {
                        that.setLoader(false);
                    }
                })
                .catch(function () {
                    that.setLoader(false);
                })
        },
        getPermission() {
            this.permission = auth.getPermission("adminapplicants");
        },
        refreshData() {
            this.getApplicantsData();
        },
        setActiveApplicant() {
            if (this.id) {
                this.$refs.applicantManager.setActiveApplicant({
                    id: this.id
                });
            } else {
                this.setNotification('#ffb822', 'mdi-account-alert', `The applicant could not be found. Either the ID is invalid or the applicant does not exist.`, true);
            }
        },
        setData(data) {
            this.data = data;
        },
        setLoader(bool) {
            this.loader = bool;
        },
        setNotification(color, icon, message, status) {
            // Reset snackbar
            this.snackbar.status = false;

            // Set snackbar fields
            this.snackbar.color = color;
            this.snackbar.icon = icon;
            this.snackbar.message = message;
            this.snackbar.status = status;
        },
        setSearch(bool) {
            this.searchBool = bool;
        }
    },
    computed: {
        appColor() {
            return '#191b2a';
        }
    },
    created() {
        this.refreshData();
        this.getPermission();
        this.refreshTimer = setInterval(this.refreshData, 60000);
    },
    beforeDestroy() {
        // Clear refresh function
        clearInterval(this.refreshTimer);
    },
    destroyed() {
        // Clear refresh function
        clearInterval(this.refreshTimer);
    }
}
</script>